import { useEffect } from 'react';
import { navigate } from 'wouter/use-browser-location';
import { Users } from '@platform/client';
import { AuthedPage, HeaderFooterLayout } from '../app';
import { ROUTES } from '../routes/consts';
import { HeroSection } from './home/HeroSection';
import { TestimonialsSection } from './home/TestimonialsSection';

const CorporateHomeContent = () => {
  const { data: user, isSuccess } = Users.useGetCurrentUser();
  const isCorporateAdmin = user?.accountType === 'corporate';

  useEffect(() => {
    if (isSuccess && !isCorporateAdmin) {
      navigate('/');
    }
  }, [isSuccess, isCorporateAdmin]);

  if (!user || !isCorporateAdmin) {
    return null;
  }

  const dashboardHref = `/platform${ROUTES.CORPORATE_DASHBOARD}`;

  return (
    <>
      <HeroSection dashboardHref={dashboardHref} />
      <TestimonialsSection />
    </>
  );
};

export const CorporateHomePage = () => (
  <AuthedPage>
    <HeaderFooterLayout>
      <CorporateHomeContent />
    </HeaderFooterLayout>
  </AuthedPage>
);
